import 'primeflex/primeflex.css';

import { ReactNode } from 'react';
import { AlertIcon } from '../icons';
import { confirmGeneric, ConfirmGenericTitle } from './confirmGeneric';
import { Description } from './styled';

type TProps = {
  caption?: string | undefined;
  description?: ReactNode;
  acceptLabel: string;
  rejectLabel?: string | undefined;
  onConfirm: any;
  onReject?: any;
  infoOnly?: boolean | undefined;
};

export const confirmAlert = ({ caption, description, acceptLabel, rejectLabel, onConfirm, onReject, infoOnly }: TProps) => {
  return confirmGeneric({
    contents: (
      <>
        <AlertIcon />
        <ConfirmGenericTitle>{caption || 'Are you sure?'}</ConfirmGenericTitle>
        <Description>{description}</Description>
      </>
    ),
    acceptLabel: acceptLabel,
    rejectLabel: rejectLabel ?? 'Cancel',
    onConfirm,
    onReject,
    infoOnly,
  });
};
